import { gsap } from 'gsap';

export interface IGalleryFilterValues {
  planValue: string;
  livingSpaceValue: string;
  intColorValue: string;
  extColorValue: string;
}

export const galleryFilters: IGalleryFilterValues = {
  planValue: 'all',
  livingSpaceValue: 'all',
  intColorValue: 'all',
  extColorValue: 'all',
};

export function updateFilters(filterType: string) {
  // Scroll to the top of the asset content container using GSAP
  const assetContent = document.getElementById(`js-${filterType}-content`); 
  if (assetContent) {
    const rect = assetContent.getBoundingClientRect();
    const offsetY = window.scrollY + rect.top - window.innerHeight * 0.3; // 30% of the viewport height
    gsap.to(window, {
      duration: 0.5,
      scrollTo: { y: offsetY, autoKill: false }, // Smoothly scroll to the calculated position
      ease: 'power2.out',
    });
  } else {
    return;
  }

  const figures = assetContent.querySelectorAll('figure');

  figures.forEach(figure => {
    const tags = figure.getAttribute('data-tags')?.split(' ');

    const matches =
      (galleryFilters.planValue === 'all' ||
        tags?.includes(`${galleryFilters.planValue}`)) &&
      (galleryFilters.livingSpaceValue === 'all' ||
        tags?.includes(`${galleryFilters.livingSpaceValue}`)) &&
      (galleryFilters.intColorValue === 'all' ||
        tags?.includes(`${galleryFilters.intColorValue}`)) &&
      (galleryFilters.extColorValue === 'all' ||
        tags?.includes(`${galleryFilters.extColorValue}`));

    // Show or hide the figure based on the match
    figure.style.display = matches ? 'block' : 'none';
  });
}

export function resetAllFilters(filterType: string) {
  // Reset the filter values to 'all'
  galleryFilters.planValue = 'all';
  galleryFilters.livingSpaceValue = 'all';
  galleryFilters.intColorValue = 'all';
  galleryFilters.extColorValue = 'all';

  // Update button states: remove 'active' from all buttons, and add 'active' to "All" buttons
  const panelContainer = document.getElementById(`js-${filterType}-filter`);

  if (panelContainer) {
    const allFilterButtons = panelContainer.querySelectorAll('.js-btn-filter');
      allFilterButtons.forEach(button => {
          button.classList.remove('active');
          button.removeAttribute('disabled');
      });

    // Find the "All" buttons and set them as active
    const allButtons = panelContainer.querySelectorAll(
      '.js-btn-filter[data-filter="all"]',
    );
    allButtons.forEach(button => button.classList.add('active'));

  }

  // Update the filters for the specified panel
  updateFilters(filterType);
}
